
(() => {

    function finishOf(item) 
    {
        const title = (item.variant_title || "")
            .trim()
            .toLowerCase();

        const finishes = {
            "polyester powder coated": "ppc",
            "polyester powder coated 2": "ppc2",
            "polyester powder coated marine": "ppcm",
            "polyester powder coated 2 marine": "ppc2m",
            "mill": "mill"
        };

        return finishes[title] || null;
    }

    function finishesCompatible(existing, requested) 
    {
        if (!existing || !requested) return false;

        return existing === requested;
    }

    function coloursCompatible(existingColour, requestedColour) 
    {
        if (!existingColour || !requestedColour) return false;

        return existingColour.trim().toUpperCase() ===
                requestedColour.trim().toUpperCase();
    }
  const root = window.Shopify?.routes?.root || "/";
  let previousCart = null;
  let busy = false;

  async function getCart() {
    const response = await fetch(root + "cart.js", {
      cache: "no-store"
    });

    if (!response.ok) {
      throw new Error("Cannot read cart");
    }

    return response.json();
  }

  function finishOf(item) {
    const value = (item.variant_title || "").toLowerCase();

    if (value.includes("mill")) return "Mill";

    if (value.includes("polyester powder coated")) {
      return "PPC";
    }

    return null;
  }

  function getQuantities(cart) {
    const quantities = new Map();

    for (const item of cart.items) {
      quantities.set(
        item.key,
        {
          quantity: item.quantity,
          finish: finishOf(item)
        }
      );
    }

    return quantities;
  }

  async function restoreQuantity(itemKey, quantity) {
    const response = await fetch(root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: itemKey,
        quantity
      })
    });

    if (!response.ok) {
      throw new Error("Unable to restore cart quantity");
    }

    return response.json();
  }

  async function checkCart() {
    if (busy) return;

    busy = true;

    try {
      const cart = await getCart();

      if (!previousCart) {
        previousCart = cart;
        return;
      }

      const oldItems = getQuantities(previousCart);

      const existingFinishes = new Set(
        previousCart.items
          .map(finishOf)
          .filter(Boolean)
      );

      // Only enforce when an existing cart has
      // a known finish.
      if (existingFinishes.size === 0) {
        previousCart = cart;
        return;
      }

      let conflictFound = false;

      for (const item of cart.items) {
        const finish = finishOf(item);

        if (!finish) continue;

        const previous = oldItems.get(item.key);
        const previousQuantity = previous?.quantity || 0;

        // Only inspect newly added quantities.
        if (item.quantity <= previousQuantity) continue;

        if (!existingFinishes.has(finish)) {
          console.warn(
            "[Rockin Rhino] Blocking incompatible finish:",
            item.title
          );

          await restoreQuantity(item.key, previousQuantity);

          conflictFound = true;
        }
      }

      // Always reload the actual cart after changes.
      previousCart = await getCart();

      if (conflictFound) {
        alert(
          "Rockin Rhino: You cannot mix Mill and " +
          "Polyester Powder Coated finishes in one cart. " +
          "The incompatible product has been removed."
        );

        // Refresh the storefront so the cart UI
        // reflects the corrected quantities.
        window.location.reload();
      }

    } catch (error) {
      console.error(
        "[Rockin Rhino] Cart guard error:",
        error
      );

      // Re-read the cart on the next check.
      previousCart = null;

    } finally {
      busy = false;
    }
  }

  async function start() {
    try {
      previousCart = await getCart();

      console.log(
        "[Rockin Rhino] Cart guard active"
      );
    } catch (error) {
      console.error(error);
    }
  }

  start();

  // Detect cart additions from Clarity and other
  // integrations every 1.5 seconds.
  setInterval(checkCart, 1500);
})();
